// extracted by mini-css-extract-plugin
export default {"movies-list":"YoutubeList_movies-list__emZhB"};